import { render, staticRenderFns } from "./itemsValoracion.vue?vue&type=template&id=3a225580&scoped=true"
import script from "./itemsValoracion.vue?vue&type=script&lang=js"
export * from "./itemsValoracion.vue?vue&type=script&lang=js"
import style0 from "./itemsValoracion.vue?vue&type=style&index=0&id=3a225580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a225580",
  null
  
)

export default component.exports